import types from '../../Store/PublicCourses/ActionTypes';
import initialState from 'Store/InitialState';

export function publicCoursesReducer(state = initialState.publicCoursesMap, action) {
    switch (action.type) {
        case types.LOAD_PUBLIC_COURSES_LIST_SUCCESS:
            return action.publicCoursesMap;
        case types.ADD_TO_PUBLIC_COURSE_LIST:
            return state.concat(action.publicCoursesMap);
        default:
            return state;
    }
};
export function paginationInfoReducer(state = initialState.paginationInfo, action) {
    switch (action.type) {
        case types.LOAD_PAGINATION_INFO_SUCCESS:
            return action.paginationInfo;
        default:
            return state;
    }
}

